import { styled } from '@mui/material';

import { AspectRatioGuard } from '../AspectRatioGuard';

export const AspectRatioGuardStyled = styled(AspectRatioGuard)(({ theme }) => ({
	backgroundColor: theme.palette.neutral[0],
	borderRadius: '8px',
}));
